import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { IconPyramid, IconCell } from '@tabler/icons';

const useStyles = makeStyles((theme) => ({
    contenedorEncabezado: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        marginBottom:"17px",
        marginTop:"30px",
    },
    circuloIcono: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        backgroundColor: "#F77F00",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginRight: "5px",
        padding:"1px"
    },
    iconoEncabezado: {
        color:"white", 
        fontSize:"1.4rem",
    },
    miTitulo:{
      fontSize:"1.1rem",
      color:"black"
    },
    espacio: {
      padding: "50px"
  }
  }));

const EncabezadoVistaCvUo = () => {
    const styles = useStyles();
  return (
    <div className={styles.contenedorEncabezado}>
        <div className={styles.circuloIcono}>
            <IconCell
              size={24}
              color="white"
              stroke={2}
              className={styles.iconoEncabezado}
            />
        </div>  
        <h6 className={styles.miTitulo}>Asignación Contrato - Centro de costo</h6>
    </div>
  )
}

export default EncabezadoVistaCvUo;